import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { IDealMoveImportResponse } from '../shared/interfaces';

export const requestFundedDateDealMoveImport = async(file: File, fundedDate: string) => {
    const url = `${SERVICES.DEAL}/DealMoveImport?FundedDate=${fundedDate}&DealMoveImportType=2`;
    const formData = new FormData();
    formData.append('files', file as string | Blob | File);

    try {
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        const response = await axios.post<IDealMoveImportResponse[]>(url, formData, config);
        return response.data;
    } catch (err) {
        Notistack.generalError(getError(err));
    }
};